module.exports = __webpack_public_path__ + "static/media/Achievement.3c00a807.webp";